<template>
<!-- FINAL ICARE -->
  <form @submit.prevent>
     <CModal
        :title.sync="title" 
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol>
            <CInput v-model="form.address1"  label="Primary Address"   />
            <CInput v-model="form.address2"  label="Secondary Address"   />
            <CInput v-model="form.zipcode"  label="Zipcode"   />
            <CInput v-model="form.city"  label="City"   />
            <CInput v-model="form.state"  label="State"   />
            <CInput v-model="form.country"  label="Country"   />
          </CCol> 
          </CRow>
       
        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'create'" type="submit" v-on:click.prevent="create()"  variant="outline" color="info">Create</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="update(form.uuid)"  variant="outline" color="info">Update</CButton>
     
        </template>
    </CModal>
  </form>
</template>
<script>
import EventBus from '@/eventBus';

import member from '@/services/member';
import satelite from '@/services/satelitechurch'
import icare from '@/services/icare'

import moment from 'moment'

export default {
name: 'covenantmodal',
  data () {
    return {
    show: false,
    title: 'Default Title',
    mode: '',
    form:{
      uuid:'',
      firstname:'',
      lastname:'',
      // dob:'',
      email:'',
      city:'',
      zipcode:'',
      address1:'',
      address2:'',
      state:'',
      country:'',
    },
    }
  },

  mounted (){
     
   },
  
  created () {
    var self = this; 
      EventBus.$on('OPEN_MODAL_ADDRESS', (params) => {
      if(params.data){
      member.getMemberbyID(params.data)
      .then(res => {
      self.show = true;
      self.title = params.title;
      self.mode = params.mode;
      self.form.uuid = params.data;
      self.form.firstname = res.data.firstname;
      self.form.lastname = res.data.lastname;
      // self.form.dob = res.data.dob;
      self.form.email = res.data.email;
      self.form.city = res.data.city;
      self.form.zipcode = res.data.zipcode;
      self.form.address1 = res.data.address1;
      self.form.address2 = res.data.address2;
      self.form.state = res.data.state;
      self.form.country = res.data.country;
       }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.uuid = "";
        self.form.firstname = "";
        self.form.lastname = "";
        self.form.city = "";
        // self.form.dob = "";
        self.form.email = "";
        self.form.address1 = "";
        self.form.address2 = "";
        self.form.zipcode = "";
        self.form.state = "";
        self.form.country = "";
      }
 
    });
    
  },
  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    update(id){
      this.show = false;
      member.updateMember(id, this.form)
      .then(res => {
        EventBus.$emit('PAGE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
  
   
  }
}
</script>

<style>

</style>